export const ds_AthleticsFixturesBlock_Entry = `
    fragment ds_AthleticsFixturesBlock_Entry on ds_AthleticsFixturesBlock_Entry {
        id
        canonicalUid
        
        athleticsFixtures_EventTypeToDisplay
        athleticsFixtures_Intro
        athleticsFixtures_FixtureStyle
        athleticsFixtures_TeamNames

        athleticsFixtures_Integration {
            integration
            teams
            sports
        }

        athleticsFixtures_ContainerWidth
        athleticsFixtures_TopSpacing
        athleticsFixtures_ColorTheme
        athleticsFixtures_ColorPalette
        athleticsFixtures_FullWidthBackground

    }
`